import { useField } from "formik";

import {
  RadioGroup,
  RadioGroupProps,
} from "../components/inputs/radio/radio-group/RadioGroup";

export interface RadioGroupFormikFieldProps extends RadioGroupProps {
  name: string;
  ariaLabel?: string;
}

export function RadioGroupFormikField(props: RadioGroupFormikFieldProps) {
  const [field, meta, helpers] = useField(props.name);

  return (
    <RadioGroup
      orientation={props.orientation}
      aria-label={props.ariaLabel || props.label}
      name={props.name}
      value={field.value}
      onChange={(value) => {
        helpers.setValue(value);
        props.onChange?.(value);
      }}
      isCard={props.isCard}
      label={props.label}
      description={props.description}
      isDisabled={props.isDisabled}
      isRequired={props.isRequired}
      isInvalid={Boolean(meta.touched && meta.error)}
      errors={meta.touched ? meta.error : undefined}
      children={props.children}
      testID={props.testID}
      defaultValue={props.defaultValue}
    />
  );
}
